import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { trackEvent } from "@/lib/api";
import { getPhase } from "@/lib/phase";

export const StickyCta = ({ onScrollToForm, submitted }) => {
  const [scrolled, setScrolled] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const phase = getPhase();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > window.innerHeight * 0.55);
    window.addEventListener("scroll", onScroll, { passive: true });
    const formEl = document.getElementById("teilnehmen");
    let observer;
    if (formEl) {
      observer = new IntersectionObserver(([entry]) => setFormVisible(entry.isIntersecting), { threshold: 0.1 });
      observer.observe(formEl);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer?.disconnect();
    };
  }, []);

  const show = phase === "active" && scrolled && !formVisible && !submitted;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.35, ease: [0.33, 1, 0.68, 1] }}
          className="fixed bottom-0 left-0 right-0 z-40 border-t border-line bg-paper/95 p-4 backdrop-blur-xl md:hidden"
          data-testid="sticky-cta-bar"
        >
          <button
            data-testid="sticky-cta-button"
            onClick={() => {
              trackEvent("cta_click", "sticky");
              onScrollToForm();
            }}
            className="flex w-full items-center justify-center rounded-[14px] bg-gold py-3.5 font-display text-lg font-extrabold tracking-tight text-ink transition-[transform,background-color] duration-200 hover:bg-gold-dark active:scale-95"
          >
            Kostenlos teilnehmen
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
